import { RootState } from '../store'

export const clientsSelector = (state: RootState) => {
  const { clients } = state

  return clients
}

export const clientsWithInvoicesSelector = (state: RootState) => {
  return state.clients.clientsWithInvoices
}
